import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero" id="hero">
      {/* Background glow blobs */}
      <div className="hero__blob hero__blob--blue" />
      <div className="hero__blob hero__blob--green" />

      <div className="hero__inner container">
        {/* Left content */}
        <div className="hero__content">
          <div className="hero__badge">
            <span className="hero__badge-dot" />
            AI-Powered Fitness Coaching
          </div>

          <h1 className="hero__title">
            Your Personal AI<br />
            <span>Fitness Coach</span><br />
            In Your Pocket
          </h1>

          <p className="hero__subtitle">
            FitMind AI builds a custom training plan around your goals, lifestyle and
            recovery — then adapts it every month based on your real progress. During
            each session it suggests the exact weights to lift based on what you did before.
            No cookie-cutter plans. Just science-backed coaching, personalised for you.
          </p>

          <div className="hero__stats">
            <div className="hero__stat">
              <span className="hero__stat-value">100%</span>
              <span className="hero__stat-label">Personalised Plans</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <span className="hero__stat-value">AI</span>
              <span className="hero__stat-label">Monthly Adaptation</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <span className="hero__stat-value">4+</span>
              <span className="hero__stat-label">Core Features</span>
            </div>
          </div>

          <div className="hero__actions">
            <a href="#download" className="btn-accent hero__btn-main">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3.18 23.76c.37.2.8.2 1.18 0l11.46-6.62-2.5-2.5L3.18 23.76zm16.46-10.26c.42-.24.67-.68.67-1.15v-.7c0-.47-.25-.91-.67-1.15L16.69 8.9l-2.8 2.8 2.8 2.8 2.95-1zM4.36.24C3.98.04 3.55.04 3.18.24L13.32 10.4 15.82 7.9 4.36.24zM2.01 1.04C1.76 1.34 1.6 1.72 1.6 2.12v19.75c0 .4.16.78.41 1.08l.06.06L13.3 11.78v-.28L2.01 1.04z"/>
              </svg>
              Get it on Google Play
            </a>
            <a href="#how-it-works" className="btn-outline">
              See How It Works
            </a>
          </div>
        </div>

        {/* Right — phone mockup with video */}
        <div className="hero__visual">
          <div className="hero__phone-wrap">
            <div className="hero__glow-ring" />
            <div className="hero__phone">
              <div className="hero__phone-notch" />
              <video
                className="hero__phone-video"
                src="/assets/videos2/switching_training_with_rest.webm"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>
            {/* Floating cards */}
            <div className="hero__float hero__float--top">
              <span className="hero__float-icon">🧠</span>
              <div>
                <div className="hero__float-title">AI adapted your plan</div>
                <div className="hero__float-sub">Monthly recalibration complete</div>
              </div>
            </div>
            <div className="hero__float hero__float--bottom">
              <span className="hero__float-icon">✅</span>
              <div>
                <div className="hero__float-title">Session Complete!</div>
                <div className="hero__float-sub">+3.2 kg bench press PR</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hero__scroll-hint">
        <span>Scroll to explore</span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 5v14M5 12l7 7 7-7"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
